var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 414,
    viewBox: "0 0 336 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 360,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.002 360C107.001 360.152 107 360.305 107 360.458C107 390.028 131.177 414 161 414C190.823 414 215 390.028 215 360.458C215 360.305 214.999 360.152 214.998 360L107.002 360Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.001 360C123 360.107 123 360.215 123 360.322C123 381.131 140.013 398 161 398C181.987 398 199 381.131 199 360.322C199 360.215 199 360.107 198.999 360L123.001 360Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.001 360C139 360.062 139 360.124 139 360.186C139 372.234 148.85 382 161 382C173.15 382 183 372.234 183 360.186C183 360.124 183 360.062 182.999 360L139.001 360Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295 42L41 310H295V42Z",
    fill: "#F7B801"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5354_143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 42,
    width: 254,
    height: 268
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295 42V310H41L295 42Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5354_143)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter0_d_5354_143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 176,
    r: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 176,
    r: 89.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 169,
    cy: 176,
    r: 69.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 169,
    cy: 176,
    r: 49.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 169,
    cy: 176,
    r: 108.5,
    stroke: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5354_143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 42,
    width: 254,
    height: 268
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295 42H41V310L295 42Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5354_143)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5354_143)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    transform: "matrix(-1 0 0 1 169 176)",
    fill: "#F7B801"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 69.5,
    transform: "matrix(-1 0 0 1 169 176)",
    stroke: "#F7B801"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 109.5,
    transform: "matrix(-1 0 0 1 169 176)",
    stroke: "#F7B801"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    r: 89.5,
    transform: "matrix(-1 0 0 1 169 176)",
    stroke: "#F7B801"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    r: 49.5,
    transform: "matrix(-1 0 0 1 169 176)",
    stroke: "#F7B801"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 215,
    r: 8,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 134,
    r: 8,
    fill: "#F7B801"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5354_143",
    x: 95,
    y: 122,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5354_143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5354_143",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5354_143",
    x: 95,
    y: 122,
    width: 148,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.635294 0 0 0 0 0.972549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5354_143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5354_143",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.135d761cd13762b73727b420e0f071f4.svg";
export { ForwardRef as ReactComponent };